import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import {
  BiTmplDetail_18_1,
  BiTmplDetail_18_2,
  BiTmplDetail_18_3,
  BiTmplDetail_18_4
} from '@/views/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-18/components/index';
import { useBiTmplDetailSteup } from '../../../store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-19',
  setup(__props) {

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const BiTmplDetail_19_s = {
  BiTmplDetail_19_1: BiTmplDetail_18_1,
  BiTmplDetail_19_2: BiTmplDetail_18_2,
  BiTmplDetail_19_3: BiTmplDetail_18_3,
  BiTmplDetail_19_4: BiTmplDetail_18_4
};
const cmpName = computed(() => {
  return BiTmplDetail_19_s['BiTmplDetail_' + state.value.activeMenu[1]];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName.value)))
  ]))
}
}

})